<template>
    <div class="element-editor" style="height:400px;overflow-y: auto;">
        <el-tabs type="border-card">
            <!-- <el-tab-pane label="关联字段条件"> -->
                 <div class="operate-btns">
                    <el-collapse v-model="activeName" accordion>
                        <el-collapse-item
                            v-for="(referenceField, index) in referenceFields"
                            :key="referenceField.id"
                            :name="index">
                            <template slot="title" >
                                <div class="button-title">
                                【<el-tag size="medium">{{referenceField.masterModelName}}</el-tag>】.(<el-tag  size="mini" type="success">{{referenceField.masterModelFieldName}}</el-tag>)    <font size="4px">=</font>   【<el-tag size="medium">{{referenceField.slaveModelName}}</el-tag>】.(<el-tag  size="mini" type="success">{{referenceField.slaveModelFieldName}}</el-tag>)
                                </div>
                                <div class="form-item-option">
                                    <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                                </div>
                            </template>
                            <!-- class="button-props" -->
                            <el-form  class="demo-form-inline" >
                                    <el-row style="width:950px">
                                            <el-col :span="10">
                                                <el-form-item  >
                                                    <el-select  class="selectFieldClass"  v-model="referenceField.masterModelId" placeholder="请选择模型"  @change="handleMasterModelChange">
                                                        <el-option
                                                            v-for="item in models"
                                                            :key="item.id"
                                                            :label="item.label"
                                                            :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select class="selectFieldClass"  v-model="referenceField.masterModelFieldId"  placeholder="请选择模型属性" @change="handleMasterModelFieldIdChange">
                                                        <el-option
                                                            v-for="item in masterModelFields[index]"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="1" >=</el-col>
                                            <el-col :span="10">
                                                <el-form-item  >
                                                    <el-select  class="selectFieldClass" v-model="referenceField.slaveModelId" placeholder="请选择模型" @change="handleSlaveModelChange">
                                                        <el-option
                                                            v-for="item in models"
                                                            :key="item.id"
                                                            :label="item.label"
                                                            :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select class="selectFieldClass"  v-model="referenceField.slaveModelFieldId" placeholder="请选择模型属性" @change="handleSlaveModelFieldIdChange">
                                                        <el-option
                                                            v-for="item in slaveModelFields[index]"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                    <el-button type="text" icon="el-icon-circle-plus-outline" plain @click="handleRelationshipAdd">添加关联条件</el-button>
                </div>
            <!-- </el-tab-pane> -->
        </el-tabs>
    </div>

</template>
<script>
    import { getUUID } from '@/utils/grocer';
    import { cloneDeep } from 'lodash';
    import { getFormConfigs } from '@/data-model';
    export default {
        data () {
            return {
                activeName: 0,
                lastActiveName: -1,
                mv: '',
                mfv: '',
                sv: '',
                sfv: '',
                masterModelFields: [],
                slaveModelFields: [],
                fieldsMap: new Map()
            };
        },
        props: {
            referenceFields: {
                type: Array
                // default: () => { return []; }
            },
            models: {
                type: Array
                // default: () => { return []; }
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async  _initPage () {
                // 初始化所有字段map映射
                await this.initAllFieldsMap().then(val => {
                    let index = 0;
                    this.referenceFields.forEach((item) => { // 初始化字段赋值
                        this.renderSelect(index, this.masterModelFields, item.masterModelId, 1, true);
                        this.renderSelect(index, this.slaveModelFields, item.slaveModelId, 2, true);
                        index++;
                    });
                    // console.log(this.myMap.get("42e72d614b454e86a5090c41990554fe"));
                });
            },
            async initAllFieldsMap () {
                this.fieldsMap = new Map();
                // console.log(this.models);
                let formIds = [];
                this.models.forEach(async (item) => {
                    formIds.push(item.formId);
                });
                let formsMap = await getFormConfigs(formIds.join(','));
                for (var key in formsMap) {
                    if (formsMap[key]) {
                        // console.log(formsMap[key].fieldsList);
                        let tempFieldsList = cloneDeep(formsMap[key].fieldsList);
                        if (formsMap[key].modelType && formsMap[key].modelType == 7) {
                            tempFieldsList.unshift({ id: 'PRIMARY-USER-KEY', name: formsMap[key].modelName + '--人员主键' });
                        }
                        tempFieldsList.unshift({ id: 'PRIMARY-KEY', name: formsMap[key].modelName + '--主键' });
                        // console.log(tempFieldsList);
                        this.fieldsMap.set(key, tempFieldsList);
                    }
                }
            },
            handleRelationshipAdd () {
                this.referenceFields.push({
                    id: getUUID(16, 16),
                    masterModelId: '',
                    masterModelName: '',
                    masterModelFieldId: '',
                    masterModelFieldName: '',
                    slaveModelId: '',
                    slaveModelName: '',
                    slaveModelFieldId: '',
                    slaveModelFieldName: '',
                    label: '',
                    type: '',
                    viewOrder: this.referenceFields.length
                });
            },
            handleDeleteItem (index) {
                this.referenceFields.splice(index, 1);
            },
            getReferenceFields () {
                return this.referenceFields;
            },
            async handleMasterModelChange (id) {
                this.renderSelect(this.activeName, this.masterModelFields, id, 1);
            },
            handleMasterModelFieldIdChange (id) {
                let selectFiled = this.masterModelFields[this.activeName].find(item => {
                    return item.id === id;
                });
                this.referenceFields[this.activeName].masterModelFieldName = selectFiled.name;
            },
            async handleSlaveModelChange (id) {
                this.renderSelect(this.activeName, this.slaveModelFields, id, 2);
            },
            handleSlaveModelFieldIdChange (id) {
                let selectFiled = this.slaveModelFields[this.activeName].find(item => {
                    return item.id === id;
                });
                this.referenceFields[this.activeName].slaveModelFieldName = selectFiled.name;
            },
            async renderSelect (index, modelFields, id, mode, isInit) {
                let selectModel = this.models.find(item => {
                    return item.id === id;
                });
                // const { fieldsList } = await getFormConfig(selectModel.formId);
                // console.log(selectModel);
                if (selectModel) {
                    let fieldsList = this.fieldsMap.get(selectModel.formId);
                    if (this.lastActiveName === index) {
                        modelFields[index] = fieldsList;
                    } else {
                        this.lastActiveName = index;
                        if (modelFields.length === 0 || modelFields.length < index) {
                            modelFields.push(fieldsList);
                        } else {
                            modelFields[index] = fieldsList;
                        }
                    }
                    if (mode === 1 && !isInit) { // 主表
                        this.referenceFields[index].masterModelName = selectModel.name;
                        this.referenceFields[index].masterModelFieldId = '';
                        this.referenceFields[index].masterModelFieldName = '';
                    } else if (mode === 2 && !isInit) { // 从表
                        this.referenceFields[index].slaveModelName = selectModel.name;
                        this.referenceFields[index].slaveModelFieldId = '';
                        this.referenceFields[index].slaveModelFieldName = '';
                    }
                }
            }
        }
    };
</script>


<style lang="less">
  .element-editor {
        .exec-type {
            .el-radio+.el-radio {
                margin-left: 0;
            }
        }
    .operate-btns {
        display: flex;
        flex-direction: column;

        .el-collapse {
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
        }

        .button-title {
            padding: 0 0 0 10px;
            flex: 1;
        }

        .form-item-option {
            // position: absolute;
            width: 20px;
            right: 50px;
            cursor: pointer;
            display: block;
        }


        .button-list {
            display: flex;
            flex-direction: column;
        }
        .button-props {
            width: 800px;
        }
    }
    }
   .selectFieldClass{
        width: 180px;
   }
</style>



// WEBPACK FOOTER //
// src/components/ReferenceField/ReferenceField.vue